import { Component } from '@angular/core';

import {CommonModule} from '@angular/common';


// Angular material components
import {MatButtonModule} from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';

// Custom services
import { UserAuthenticationService } from '../../../services/google/user-authentication.service';
import { LanguageService } from '../../../services/language/language.service';
import { UtilsService } from '../../../services/utils/utils.service';



@Component({
  selector: 'app-login-page',
  imports: [
    // Angular modules
    CommonModule,
    MatButtonModule,
    MatIconModule,
  ],
  templateUrl: './login-page.component.html',
  styleUrl: './login-page.component.css'
})
export class LoginPageComponent {

  constructor(
    //public controllerService:ControllerService,
    public userAuthenticationService:UserAuthenticationService,
    public languageService:LanguageService,
    public utilsService:UtilsService
  ){}



  async loginButtonclicked(){
    // Prepare the result dict   
    const resultDict = await this.userAuthenticationService.loginWithProvider()
    // Manage the result
    if(resultDict['resultOk'] == true) return // Return if everything is ok
    // TODO: TBD - Manage errors
    console.log(resultDict)  
  }



}
